var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsRoomServiceRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 31.6667C4.52776 31.6667 4.13221 31.5068 3.81332 31.1868C3.49443 30.8668 3.33443 30.4712 3.33332 30.0001C3.33221 29.529 3.49221 29.1334 3.81332 28.8134C4.13443 28.4934 4.52999 28.3334 4.99999 28.3334H35C35.4722 28.3334 35.8683 28.4934 36.1883 28.8134C36.5083 29.1334 36.6678 29.529 36.6666 30.0001C36.6655 30.4712 36.5055 30.8673 36.1866 31.1884C35.8678 31.5095 35.4722 31.669 35 31.6667H4.99999ZM4.99999 26.6667V25.0001C4.99999 21.4445 6.09054 18.3056 8.27165 15.5834C10.4528 12.8612 13.2511 11.139 16.6667 10.4168V10.0001C16.6667 9.08342 16.9933 8.29897 17.6467 7.64675C18.3 6.99453 19.0844 6.66786 20 6.66675C20.9155 6.66564 21.7005 6.99231 22.355 7.64675C23.0094 8.30119 23.3355 9.08564 23.3333 10.0001V10.4168C26.7778 11.139 29.5833 12.8612 31.75 15.5834C33.9166 18.3056 35 21.4445 35 25.0001V26.6667H4.99999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsRoomServiceRounded);
export default __webpack_public_path__ + "static/media/material-symbols_room-service-rounded.dcb29fb4154f35c19736baa5ee4ca7e2.svg";
export { ForwardRef as ReactComponent };